/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class LeaveTabDirective {
    public restrict = 'E';
    public scope: {
        val: '='
    };
    public template;
    public value;
    public tab;
    constructor(private Process: IProcessService, private bsLoadingOverlayService: IBsLoadingService) {
        this.restrict = 'E';
        // <tr ng-repeat="l in typeArray  | filter: {type:&quot;paid&quot;} | orderBy:[&quot;start_date&quot;]:true as index track by $index" ng-if="l.type === &quot;paid&quot; &amp;&amp; !l.deleted">
        this.template = `
        <div >
        <div class="panel">
            <div class="padding-style-1 white-background table-padding tab-table-border">

                <table class="table table-material md-custom-table" >
                    <thead>
                        <th class="first_col">Dates</th>
                        <th>Days Used</th>
                        <th>Reason</th>
                        <th>Attachment</th>
                        <th colspan="2">Actions</th>
                    </thead>
                    <tbody>
                        <tr ng-repeat="l in typeArray | orderBy: l.start_date:true | limitTo:numLimit:start ">
                            <td ng-if='l.type != "noLeave"' >{{l.start_date | date: 'dd.MM.yyyy'}} - {{l.end_date | date: 'dd.MM.yyyy'}}</td>
                            <td ng-if='l.type != "noLeave"' class="d-none d-md-table-cell">{{l.leave_days_used}} days used</td>
                            <td ng-if='l.type != "noLeave"' class="d-none d-md-table-cell">{{l.note}}</td>
                            <td ng-if="l.type != 'noLeave'"><span ng-if="l.file"><a href="{{l.file}}" target="_blank" class="b-blue">Download</a></span></td>
                            <td ng-if="l.type != 'noLeave'"><span ng-if="C.checkPermission('org.change_org')"><a ng-click="C.delete_leave_modal(l)" class="b-blue">Delete / Cancel</a></span></td>
                            <td ng-if="l.type != 'noLeave'"><span ng-if="C.checkPermission('org.change_org')"><a ng-click="C.archive_leave_modal(l)" class="b-blue">Archive</a></span></td>
                            <td ng-if='l.type == "noLeave"' colspan="6"> No leave items </td>
                        </tr>
                    </tbody>
                </table>
                
                </div>
                <div class="content paging-container m-t-10">
                    <ul class="pagination flex-center" ng-show="numLimit < typeArray.length">
                        <md-button class="md-raised md-primary d-inline-block" ng-hide="hidePrev()"  ng-click="PrevPage()">Previous</md-button>
                        <md-button class="md-raised md-primary d-inline-block pagination-button">{{currentPage}}</md-button>
                        <md-button class="md-raised md-primary d-inline-block" ng-hide="hideNext()" ng-click="nextPage()">Next</md-button>
                    </ul>
                </div>
            </div>
        </div>
        `
    }

    public link($scope: any, $element: any, attrs: any): void {
        $scope.currentPage=1;
        $scope.numLimit=10;
        $scope.start = 0;
        $scope.typeArray = [];
        $scope.countArray = [];
        $scope.queryType = attrs.tab;
        $scope.index = attrs.index;
        $scope.$watch(() => attrs.val, (n) => {
            if (n !== '') {
                const parseData = JSON.parse(n);                
                const getData = parseData.filter(leave => leave.type === $scope.queryType && !leave.deleted);
                $scope.typeArray = getData.sort((a,b) => { return new Date(a.start_date).getTime() - new Date(b.start_date).getTime()});
                $scope.pages=Math.ceil($scope.typeArray.length/$scope.numLimit);
                if ($scope.typeArray.length === 0) {
                    $scope.typeArray.push({type:'noLeave'})
                }
            }
        });
        $scope.hideNext=function(){
            if(($scope.start+ $scope.numLimit) < $scope.typeArray.length){
              return false;
            }
            else 
            return true;
          };
        $scope.hidePrev=function(){
        if($scope.start===0){
            return true;
        }
        else 
        return false;
        };
        $scope.nextPage=function(){
            $scope.currentPage++;
            $scope.start=$scope.start+ $scope.numLimit;
        };
        $scope.PrevPage=function(){
            if($scope.currentPage>1){
                $scope.currentPage--;
              }
              $scope.start=$scope.start - $scope.numLimit;
        }
    }



    public static DirectiveFn(
        Process: IProcessService,
        bsLoadingOverlayService: IBsLoadingService
    ): LeaveTabDirective {
        return new LeaveTabDirective(Process, bsLoadingOverlayService);
    }
}

LeaveTabDirective.DirectiveFn.$inject = ['Process', 'bsLoadingOverlayService'];

angular.module('beneple.global').directive('leaveTab', LeaveTabDirective.DirectiveFn);




// WEBPACK FOOTER //
// ./frontend/scripts/global/directives/leave_tab.directive.ts